import { isClient } from 'js/util/util.js'
import { startDrop } from '@filez/js-2-native'

export default function (options, callback) {
  // 定义遮罩
  const mask = document.createElement('div')
  const { body } = document
  mask.id = 'drag-mask'
  mask.style.left = 0
  mask.style.top = 0
  mask.style.right = 0
  mask.style.bottom = 0
  if (isClient()) {
    mask.className = 'drag-upload-mask-client'
  }
  // 设置遮罩状态
  let isMask = false
  /**
     * 显示遮罩的方法
     */
  const showMask = () => {
    const maskInBody = document.getElementById('drag-mask')
    if (!maskInBody) {
      body.appendChild(mask)
      mask.addEventListener('mousedown', () => { body.removeChild(mask) })
    }
  }
  /**
     * 隐藏遮罩的方法
     */
  const hideMask = () => {
    isMask = false
    // 判单一个段落相当于另一个段落的距离
    const allowMask = body.compareDocumentPosition(mask)
    if (allowMask & 16) {
      if (!isClient()) {
        const sub = document.getElementById('subel')
        mask.removeChild(sub)
      }
      body.removeChild(mask)
    }
  }


  // +------------------拖拽上传监听事件开始--------------------------+

  /**
     *当元素或者选择的文本被拖拽到一个有效的放置目标上时，触发 dragover 事件(每几百毫秒触发一次)。
     */
  body.addEventListener('dragover', (e) => {
    // 阻止默认事件都应该放在外边，浏览器默认的拖动事件会发生很奇怪的事情
    e.preventDefault()
    e.stopPropagation()
  }, false)

  /**
     * 当拖动的元素或被选择的文本进入有效的放置目标时， dragenter 事件被触发。
     */
  body.addEventListener('dragenter', (e) => {
    e.stopPropagation()
    e.preventDefault()
    // 显示遮罩
    showMask()
    if (isMask) { return }
    if (!isClient()) {
      // 取整个列表的位置
      const listE = document.getElementById('list-wrapper')
      const listBond = listE.getBoundingClientRect()
      // 获取浏览器的宽度
      const winWith = window.innerWidth
      const maskInBody = document.getElementById('drag-mask')
      const subInBody = document.getElementById('subel')

      // 创建一个子元素
      const sub = document.createElement('div')
      sub.id = 'subel'
      sub.innerHTML = options.i18n.t('上传到当前目录下')
      sub.className = 'drag-upload-mask'
      sub.style.left = `${listBond.left}px`
      sub.style.top = `${listBond.top}px`
      sub.style.lineHeight = `${listBond.height}px`
      sub.style.right = `${winWith - listBond.right}px`
      if (maskInBody && !subInBody) {
        document.getElementById('drag-mask').appendChild(sub)
      }
    }
    isMask = true
  }, false)

  /**
     * 当一个被拖动的元素或者被选择的文本离开一个有效的拖放目标时，将会触发dragleave 事件。
     */
  body.addEventListener('dragleave', (e) => {
    e.preventDefault()
    e.stopPropagation()
    if ((e.clientX == 0 && e.clientY == 0) || (!e.relatedTarget && (e.clientX > document.documentElement.clientWidth || e.clientX < 0 || e.clientY > document.documentElement.clientHeight || e.clientY < 0))) {
      // 当拖拽离开时移除遮罩层
      hideMask()
    }
  }, false)

  /**
     * 拖放事件在拖放操作结束时触发(通过释放鼠标按钮或单击escape键)。这个方法其实没有触发...
     */
  body.addEventListener('dragend', (e) => {
    e.preventDefault()
    e.stopPropagation()
    // 隐藏遮罩
    hideMask()
  }, false)

  /**
     * 当一个元素或是选中的文字被拖拽释放到一个有效的释放目标位置时，drop 事件被抛出。
     */
  body.addEventListener('drop', (e) => {
    e.preventDefault()
    e.stopPropagation()
    // 隐藏遮罩
    hideMask()
    if (isClient()) {
      startDrop()
      return
    }
    const { files } = e.dataTransfer
    // 采用回调传递出选中的fileData
    if (e.dataTransfer.items) {
      callback(files, e.dataTransfer.items)
    } else {
      callback(files)
    }
  }, false)
}
